module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1p3UZ"))).then(() => parcelRequire('d0iPb'));